import { useState } from "react";
import { Title, useNotify } from "react-admin";
import { Button, TextField, CircularProgress } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import downloadCycleZip from "./functions/downloadCycleZip";
import styles from "./index.styles";

const CycleZipDownload = () => {
  const notify = useNotify();
  const [cycleId, setCycleId] = useState();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    await downloadCycleZip({ cycleId, notify });
    setLoading(false);
  };

  return (
    <div style={styles.screen}>
      <Title title="Baixar XMLs" />
      <div style={styles.container}>
        <TextField
          label="Ciclo"
          variant="standard"
          type="number"
          value={cycleId}
          onChange={(e) => {
            if (e.target.value.length <= 9) {
              setCycleId(e.target.value);
            }
          }}
        />
        <Button
          variant="contained"
          endIcon={loading ? <CircularProgress size={20} /> : <GetAppIcon />}
          color="primary"
          disabled={loading}
          onClick={handleDownload}
        >
          {loading ? "Carregando..." : "Baixar XMLs"}
        </Button>
      </div>
    </div>
  );
};

export default CycleZipDownload;
